// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-area-cards {
  display: flex;
  margin-top: 12px;
  font-family: "Cairo";
  border: 2px dashed var(--blue-color);
  border-radius: 20px;
  overflow: hidden;
  margin: 30px 0;
}
@media (max-width: 992px) {
  .content-area-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 576px) {
  .content-area-cards {
    grid-template-columns: 100%;
  }
}
.content-area-cards .area-card {
  background-color: var(--secondary-color);
  display: flex;
  align-items: center;
  border-radius: 5px;
  padding: 20px 16px;
  justify-content: space-between;
  box-shadow: var(--light-shadow1);
}
@media (max-width: 768px) {
  .content-area-cards .area-card {
    padding: 12px;
  }
}
.content-area-cards .area-card .info-title {
  color: var(--lg-text-color);
  font-size: 18px;
  font-family: "Cairo";
  margin-bottom: 8px;
  font-weight: bold;
}
.content-area-cards .area-card .info-value {
  color: var(--blue-color);
  font-weight: 800;
  font-size: 2rem;
  font-family: "Cairo";
  margin-bottom: 8px;
}
.content-area-cards .area-card .info-text {
  color: var(--base-text-color);
  font-weight: 500;
}

.recharts-default-tooltip {
  padding: 4px 8px !important;
  box-shadow: rgba(0, 0, 0, 0.07) 0px 4px 12px;
  border-radius: 4px;
  background-color: var(--secondary-color) !important;
  border: 1px solid var(--border-color-inverted) !important;
}

.recharts-tooltip-item-list * {
  color: var(--text-color-inverted) !important;
  font-size: 14px;
  font-family: "Cairo";
  font-family: inherit !important;
  opacity: 0.9;
}`, "",{"version":3,"sources":["webpack://./src/components/areaCards/AreaCards.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EAEA,gBAAA;EAEA,oBAAA;EASA,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AATF;AAFE;EANF;IAOI,qCAAA;EAKF;AACF;AAHE;EAVF;IAWI,2BAAA;EAMF;AACF;AAAE;EACE,wCAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,gCAAA;AAEJ;AAAI;EATF;IAUI,aAAA;EAGJ;AACF;AADI;EACE,2BAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;AAGN;AAAI;EACE,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EAEA,kBAAA;AACN;AAEI;EACE,6BAAA;EACA,gBAAA;AAAN;;AAMA;EACE,2BAAA;EACA,4CAAA;EACA,kBAAA;EACA,mDAAA;EACA,yDAAA;AAHF;;AAOE;EACE,4CAAA;EACA,eAAA;EACA,oBAAA;EAEA,+BAAA;EACA,YAAA;AALJ","sourcesContent":[".content-area-cards {\n  display: flex;\n  // grid-template-columns: repeat(3, 1fr);\n  margin-top: 12px;\n  // gap: 16px;\n  font-family: \"Cairo\";\n  @media (max-width: 992px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  @media (max-width: 576px) {\n    grid-template-columns: 100%;\n  }\n\n  border: 2px dashed var(--blue-color);\n  border-radius: 20px;\n  overflow: hidden;\n  margin: 30px 0;\n  .area-card {\n    background-color: var(--secondary-color);\n    display: flex;\n    align-items: center;\n    border-radius: 5px;\n    padding: 20px 16px;\n    justify-content: space-between;\n    box-shadow: var(--light-shadow1);\n\n    @media (max-width: 768px) {\n      padding: 12px;\n    }\n\n    .info-title {\n      color: var(--lg-text-color);\n      font-size: 18px;\n      font-family: \"Cairo\";\n      margin-bottom: 8px;\n      font-weight: bold;\n    }\n\n    .info-value {\n      color: var(--blue-color);\n      font-weight: 800;\n      font-size: 2rem;\n      font-family: \"Cairo\";\n\n      margin-bottom: 8px;\n    }\n\n    .info-text {\n      color: var(--base-text-color);\n      font-weight: 500;\n    }\n  }\n}\n\n// global recharts tooltip customization\n.recharts-default-tooltip {\n  padding: 4px 8px !important;\n  box-shadow: rgba(0, 0, 0, 0.07) 0px 4px 12px;\n  border-radius: 4px;\n  background-color: var(--secondary-color) !important;\n  border: 1px solid var(--border-color-inverted) !important;\n}\n\n.recharts-tooltip-item-list {\n  * {\n    color: var(--text-color-inverted) !important;\n    font-size: 14px;\n    font-family: \"Cairo\";\n\n    font-family: inherit !important;\n    opacity: 0.9;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
